import './logistics-vehicle-api.factory';
import './logistics-vehicle-location-api.factory';
import './logistics-vehicle-requests.service';
import './logistics-vehicle-service.service'
import './logistics-vehicles-alerts.service'
import './logistics-vehicles-dialogs-service.service';


